module.exports = __webpack_public_path__ + "img/foot-1.37151516.png";